import {badge} from '@xh/hoist/cmp/badge';
import './SecBadges.scss';
import {Icon} from '@xh/hoist/icon';
import {coinVerticalIcon} from '../../../core/Icons';

export function secTypeBadge(type) {
    return badge({item: type, className: `security-type-badge-${type}`});
}

export function secSubTypeBadge(subType) {
    return badge({item: subType, className: `security-type-badge-${subType}`});
}

export function secExchangeBadge(exchange) {
    return badge({
        icon: Icon.fund(),
        item: exchange,
        className: `security-type-badge-${exchange}`
    });
}

export function secCurrencyBadge(currency) {
    return badge({
        icon: coinVerticalIcon(),
        item: currency,
        className: 'security-type-badge-currency'
    });
}
